<div class="tw-mt-6 lg:tw-mt-12">
  <div class="tw-flex tw-items-center tw-gap-4 tw-pb-4">
    <h1
      class="tw-text-gray-700 tw-text-lg tw-font-bold lg:tw-text-3xl tw-font-inter tw-flex tw-items-center tw-gap-3"
    >
      Location & Timezone
      <span
        class="tw-hidden lg:tw-block"
        [ngxTippy]="locationTooltipContent"
        [tippyProps]="{ allowHTML: true, placement: 'right', maxWidth: 436, theme: 'dark' }"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 24C9.62663 24 7.30655 23.2962 5.33316 21.9776C3.35977 20.6591 1.8217 18.7849 0.913451 16.5922C0.00519941 14.3995 -0.232441 11.9867 0.230582 9.65892C0.693605 7.33115 1.83649 5.19295 3.51472 3.51472C5.19295 1.83649 7.33115 0.693605 9.65892 0.230582C11.9867 -0.232441 14.3995 0.00519941 16.5922 0.913451C18.7849 1.8217 20.6591 3.35977 21.9776 5.33316C23.2962 7.30655 24 9.62663 24 12C23.9965 15.1815 22.7311 18.2317 20.4814 20.4814C18.2317 22.7311 15.1815 23.9965 12 24ZM12 2.40001C10.1013 2.40001 8.24524 2.96304 6.66653 4.0179C5.08782 5.07276 3.85736 6.57207 3.13076 8.32624C2.40416 10.0804 2.21405 12.0107 2.58447 13.8729C2.95488 15.7351 3.8692 17.4456 5.21178 18.7882C6.55436 20.1308 8.26492 21.0451 10.1271 21.4155C11.9894 21.786 13.9196 21.5958 15.6738 20.8692C17.4279 20.1426 18.9272 18.9122 19.9821 17.3335C21.037 15.7548 21.6 13.8987 21.6 12C21.5971 9.4548 20.5848 7.01467 18.7851 5.21494C16.9853 3.41521 14.5452 2.40286 12 2.40001Z"
            fill="#6B7280"
          />
          <path
            d="M12 18C11.6817 18 11.3765 17.8736 11.1515 17.6485C10.9264 17.4235 10.8 17.1183 10.8 16.8V12H9.6C9.28174 12 8.97652 11.8736 8.75148 11.6485C8.52643 11.4235 8.4 11.1183 8.4 10.8C8.4 10.4817 8.52643 10.1765 8.75148 9.95148C8.97652 9.72643 9.28174 9.6 9.6 9.6H12C12.3183 9.6 12.6235 9.72643 12.8485 9.95148C13.0736 10.1765 13.2 10.4817 13.2 10.8V16.8C13.2 17.1183 13.0736 17.4235 12.8485 17.6485C12.6235 17.8736 12.3183 18 12 18Z"
            fill="#6B7280"
          />
          <path
            d="M14.4 18H9.6C9.28174 18 8.97652 17.8736 8.75148 17.6485C8.52643 17.4235 8.4 17.1183 8.4 16.8C8.4 16.4817 8.52643 16.1765 8.75148 15.9515C8.97652 15.7264 9.28174 15.6 9.6 15.6H14.4C14.7183 15.6 15.0235 15.7264 15.2485 15.9515C15.4736 16.1765 15.6 16.4817 15.6 16.8C15.6 17.1183 15.4736 17.4235 15.2485 17.6485C15.0235 17.8736 14.7183 18 14.4 18Z"
            fill="#6B7280"
          />
          <path
            d="M11.4 8.4C12.3941 8.4 13.2 7.59412 13.2 6.6C13.2 5.60589 12.3941 4.8 11.4 4.8C10.4059 4.8 9.6 5.60589 9.6 6.6C9.6 7.59412 10.4059 8.4 11.4 8.4Z"
            fill="#6B7280"
          />
        </svg>
      </span>
    </h1>
    @if (isSaving() || showSavedIndicator()) {
      <app-saving-indicator
        [state]="isSaving() ? 'saving' : 'saved'"
        (savedDone)="onSavedIndicatorDone()"
      ></app-saving-indicator>
    }
  </div>

  <div
    class="tw-w-full tw-p-4 tw-bg-white tw-rounded-xl tw-border-gray-200 tw-border tw-inline-flex tw-flex-col tw-justify-start tw-items-start tw-gap-4 tw-overflow-hidden tw-mb-6"
  >
    <h2 class="tw-text-lg tw-text-gray-700 tw-font-bold tw-font-inter">
      Event location and timezone
    </h2>

    <app-dropdown
      #locationDropdown
      [dropdownOptions]="locationOptions()"
      [isField]="true"
      [optionGapInPX]="6"
      [hasSearchQuery]="hasSearchQuery()"
      [forceHide]="!hasSearchQuery()"
      [widthInPX]="'100%'"
      [dropdownListXPosition]="'auto'"
      [dropdownListYPosition]="'bottom'"
      (optionClicked)="onLocationOptionClicked($event)"
      (dropdownOpened)="isLocationDropdownOpen = true"
      (dropdownClosed)="isLocationDropdownOpen = false"
      class="tw-w-full"
    >
      <div
        class="tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-2 tw-bg-neutral-secondary-medium tw-border tw-border-gray-300 tw-rounded-lg tw-shadow-xs tw-p-2.5 lg:tw-px-4 lg:tw-py-2 focus-within:tw-border-blue-600"
      >
        <div class="tw-flex tw-items-center tw-gap-2 tw-flex-1">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_41500_552)">
              <path
                d="M5.60007 11.2C4.49248 11.2 3.40976 10.8716 2.48884 10.2562C1.56791 9.64089 0.850138 8.76629 0.426282 7.74302C0.0024264 6.71976 -0.108474 5.59379 0.107606 4.50749C0.323686 3.4212 0.857041 2.42338 1.64022 1.6402C2.42341 0.85703 3.42124 0.323682 4.50755 0.107605C5.59386 -0.108472 6.71984 0.00242637 7.74312 0.426277C8.7664 0.850127 9.64101 1.56789 10.2564 2.48881C10.8717 3.40972 11.2001 4.49242 11.2001 5.6C11.1985 7.0847 10.6079 8.50811 9.55807 9.55795C8.50822 10.6078 7.08479 11.1983 5.60007 11.2ZM5.60007 1.4C4.76938 1.4 3.95734 1.64633 3.26665 2.10783C2.57595 2.56933 2.03762 3.22528 1.71973 3.99273C1.40184 4.76018 1.31866 5.60466 1.48072 6.41938C1.64278 7.2341 2.0428 7.98247 2.63018 8.56985C3.21757 9.15723 3.96595 9.55724 4.78068 9.71929C5.59541 9.88135 6.4399 9.79818 7.20736 9.48029C7.97482 9.1624 8.63077 8.62408 9.09228 7.93339C9.55379 7.24271 9.80012 6.43068 9.80012 5.6C9.799 4.48643 9.35614 3.41879 8.56872 2.63138C7.7813 1.84397 6.71365 1.40111 5.60007 1.4Z"
                fill="#6B7280"
              />
              <path
                d="M13.3001 14C13.1145 14 12.9365 13.9262 12.8052 13.7949L10.0052 10.9949C9.87769 10.8629 9.80713 10.6861 9.80873 10.5025C9.81032 10.319 9.88394 10.1434 10.0137 10.0136C10.1435 9.88384 10.3191 9.81022 10.5026 9.80863C10.6862 9.80703 10.863 9.87759 10.995 10.0051L13.795 12.8051C13.8929 12.903 13.9596 13.0277 13.9866 13.1635C14.0136 13.2992 13.9997 13.44 13.9467 13.5679C13.8938 13.6957 13.8041 13.8051 13.689 13.882C13.5739 13.9589 13.4386 14 13.3001 14Z"
                fill="#6B7280"
              />
            </g>
            <defs>
              <clipPath id="clip0_41500_552">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <input
            #locationSearchInput
            [formControl]="locationControl"
            type="text"
            id="search"
            class="tw-truncate tw-w-full tw-bg-transparent tw-border-none tw-outline-none tw-text-gray-900 placeholder:tw-text-gray-500 tw-text-sm lg:tw-text-base"
            placeholder="Search by venue name, address, or city"
            autocomplete="off"
          />
        </div>

        <button
          type="button"
          class="-tw-mr-2 tw-flex tw-items-center tw-justify-center tw-w-[34px] tw-h-[34px] tw-bg-brand tw-shadow-xs tw-bg-blue-600 tw-rounded-md"
          aria-label="Use current location"
          ngxTippy="Use my current location"
          (click)="$event.stopPropagation(); setCurrentLocation()"
        >
          <i class="fas fa-crosshairs tw-text-white"></i>
        </button>
      </div>
    </app-dropdown>

    <div class="tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-3">
      <div class="tw-w-full tw-rounded-xl tw-overflow-hidden google-map-container">
        @if (mapState().center && mapState().marker) {
          <google-map
            #eventMap
            [height]="'100%'"
            [width]="'100%'"
            [options]="mapOptions"
            [center]="mapState().center"
            [zoom]="mapState().zoom"
            (zoomChanged)="onMapZoomChanged()"
          >
            <map-marker [position]="mapState().marker" [options]="markerOptions" (mapDragend)="onMarkerDragEnd($event)"></map-marker>
          </google-map>
        }
      </div>
          <span class="tw-text-blue-800 tw-text-xs tw-font-medium tw-bg-blue-100 tw-w-fit tw-px-1 tw-py-0.5  tw-rounded tw-font-inter">
            {{ selectedCity() }} {{ selectedTimezoneLabel() }}
          </span>
    </div>
    <div class=" tw-flex tw-flex-col tw-gap-1 tw-w-full">
      <p class="tw-text-gray-500 tw-text-xs tw-font-inter tw-px-1">Displayed venue name</p>
      <basic-input
      [control]="eventLocationForm.get('venue_name')"
      [placeholder]="'Venue Name'"
      [id]="'venue-name'"
      [mode]="BasicInputMode.INLINE"
      [allowClearButton]="false"
      [required]="true"
      (onBlurValueChange)="handleLocationFieldBlur('venue_name')"
      (onKeydown)="handleLocationFieldKeydown($event)"
      class="tw-w-full"
    ></basic-input>
    </div>

    <div class=" tw-flex tw-flex-col tw-gap-1 tw-w-full">
      <p class="tw-text-gray-500 tw-text-xs tw-font-inter tw-px-1">Displayed venue address</p>
      <basic-input
      [control]="eventLocationForm.get('venue_address')"
      [placeholder]="'Venue Address'"
      [id]="'venue-address'"
      [mode]="BasicInputMode.INLINE"
      [allowClearButton]="false"
      [required]="true"
      (onBlurValueChange)="handleLocationFieldBlur('venue_address')"
      (onKeydown)="handleLocationFieldKeydown($event)"
      class="tw-w-full"
    ></basic-input>
    </div>
  </div>
</div>
